<span class="badge px-2 py-1" [ngClass]="getBadgeClass()">
    {{ source }}
</span>
